/**
 * 图表数值展示格式契约类型。
 *
 * @see constants.ts · utils.ts
 * @归属 chartEditor/displayFormat
 */

import type { TFieldType } from '@dbl/core/dataSource';

/**
 * 数值显示单位：图表展示格式（bmk / 千分位小数）的合法取值集合。
 *
 * @core 拖拽字段编辑、Chart 渲染、Dashboard 卡片读同一 unit 协议；
 *       放 FieldEditComponents 会导致 ChartTragCard / TableTragCard 反向依赖组件路径。
 */
export const NumericalUnit = {
  BMK: 'bmk',
  ORIGINAL: 'thousandsDecimals',
} as const;

export type TNumericalUnit = (typeof NumericalUnit)[keyof typeof NumericalUnit];

/** 旧图表字段读显配置时的输入（存库 metric / dimension 片段）。 */
export interface IOldChartFieldDisplayData {
  column_type?: TFieldType;
  aggregate?: string;
  accuracy?: number;
  unit?: TNumericalUnit;
}

/**
 * 补齐后的数值展示配置（accuracy / unit）。
 *
 * @core ChartTragCard、多维 model 保存与渲染共用输出结构。
 */
export interface IChartDisplayConfig {
  accuracy?: number;
  unit?: TNumericalUnit;
}
